export default __webpack_public_path__ + "static/media/translation_join_call.dc094cde.svg";